module.exports = __webpack_public_path__ + "img/ttshop_dfk.ad8cb5b9.svg";